import React, {useEffect, useState} from 'react'
import {Container, Grid, Image, Label} from 'semantic-ui-react';
import {fetchPeopleCourses} from "../../../../redux/actions";
import {NavLink} from "react-router-dom";

const token = sessionStorage.getItem('Token')

const Course = ({item}) => {
    const course = item.course || {};
    const cover = course.cover ? course.path + course.cover : false;
    const link = (item.status === 3 || item.status === 4) ? `/people/course/${item.id}/${item.uuid}` : '/people/courses';
    return (
        <NavLink to={link}>
            <div className={'course-item'}>
                <div>
                    <Image
                        src={cover || 'https://img-a.udemycdn.com/course/240x135/1586752_2d9e_2.jpg'}
                    />
                </div>
                <div>
                    <Label
                        size={"tiny"}
                        color={(item.status === 3 || item.status === 4) ? 'green' : undefined}
                        content={item.course.free ? 'Curso grátis' : item.status_text}
                    />
                    <h4>{course.name}</h4>
                    <p>{course.description.substr(0, 200)}...</p>
                </div>
            </div>
        </NavLink>
    );
}

export const Courses = () => {

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const fetchData = async () => {
        setLoading(true);

        try {
            const res = await fetchPeopleCourses({active: 1, product: 0});

            setItems(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        async function getData() {
            await fetchData();
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);

    return (
        <Container>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        {
                            items.map(item => <Course item={item}/>)
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    )
}